import { useSegments } from '@hooks';
import { Segments } from '@models';
import { LayoutConfirmationFooter, OrderTableSegmens } from '@molecules';
import { PageHeader } from '@organisms';
import { Collapse } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useBreadcrumbs } from 'src/features/layout/hooks/useBreadcrumbs';

import * as S from './SegmentsOrdering.style';

const sortForBanner = (
  data: Segments.SegmentsDto[]
): Segments.SegmentsDto[] => {
  const newData = [...data];
  return newData.sort((a, b) => {
    if (!a.orderingForBanners?.length) return 1;
    if (!b.orderingForBanners?.length) return -1;

    return a.orderingForBanners[0].order - b.orderingForBanners[0].order;
  });
};

const configureForBanner = (
  data: Segments.SegmentsDto[]
): Segments.SegmentsDto[] => {
  const newData = [...data];
  return newData.map(data => ({
    ...data,
    isNew: !data.orderingForBanners?.length,
  }));
};

export const SegmentsOrdering: React.FC = () => {
  const [currentCollapse, setCurrentCollapse] = useState<string | string[]>('');
  const [listReadyToShow, setListReadyToShow] =
    useState<Segments.SegmentsDto[]>();
  const [listWithOrderChanged, setListWithOrderChanged] =
    useState<Segments.SegmentsDto[]>();

  useBreadcrumbs([
    {
      label: 'Ordenação de banners',
    },
  ]);

  const { segmentsList, getSegmentsList, saveOrder } = useSegments();
  const navigate = useNavigate();

  useEffect(() => {
    getSegmentsList({ take: 1000, skip: 0 });
  }, []);

  useEffect(() => {
    switch (currentCollapse) {
      case 'BANNERS':
        setListReadyToShow(
          configureForBanner(sortForBanner(segmentsList?.rows || []))
        );
        break;

      default:
        break;
    }
  }, [currentCollapse, segmentsList]);
  return (
    <LayoutConfirmationFooter
      ableToSave={!!listWithOrderChanged?.length}
      onSave={() => saveOrder(listWithOrderChanged || [])}
      onCancel={() => navigate('/home')}
    >
      <PageHeader
        backToPath='/home'
        title='Ordenar Segmentos'
        subTitle='Ordene os Segmentos dentro de cada módulo de acordo com a sua prioridade.'
      />

      <S.CollapseContainer>
        <Collapse
          accordion
          onChange={key =>
            setCurrentCollapse(Array.isArray(key) ? key[0] : key)
          }
          activeKey={currentCollapse}
          items={[
            {
              key: 'BANNERS',
              label: 'Banners',
              children: (
                <>
                  {!!listReadyToShow?.length && (
                    <OrderTableSegmens
                      columnTitle='Banners'
                      changeOrder={newOrder =>
                        setListWithOrderChanged(
                          newOrder as Segments.SegmentsDto[]
                        )
                      }
                      datakey='name'
                      datasource={listReadyToShow || []}
                      showHeader={false}
                    />
                  )}
                </>
              ),
            },
          ]}
        />
      </S.CollapseContainer>
    </LayoutConfirmationFooter>
  );
};
